import { RefObject } from 'react';

import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import { type Table as ReactTableType } from '@tanstack/react-table';
import { IconDownload } from '@tabler/icons-react';

import TableSearchInput from '@components/TableSearchInput';
import useTableExport from '@hooks/useTableExport';

interface AdminTokenUsageTotalTableToolbarProps<T extends Record<string, any>> {
  table: ReactTableType<T>;
  tableRef: RefObject<HTMLTableElement> | null;
}

function AdminTokenUsageTotalTableToolbar<TData extends Record<string, any>>({
  table,
  tableRef,
}: AdminTokenUsageTotalTableToolbarProps<TData>) {
  const { exportTableToXLSX } = useTableExport();

  const handleExport = () => {
    if (tableRef?.current) {
      exportTableToXLSX(tableRef, 'Total-Metrics');
    }
  };

  return (
    <Box display="flex" gap={2} alignItems="center">
      <Typography variant="h3">Totals</Typography>
      <TableSearchInput
        value={table.getState().globalFilter ?? ''}
        onClear={() => table.setGlobalFilter('')}
        onChange={(value) => table.setGlobalFilter(value)}
      />
      <Button
        variant="contained"
        color="primary"
        startIcon={<IconDownload />}
        onClick={handleExport}
      >
        Download Excel
      </Button>
    </Box>
  );
}

export default AdminTokenUsageTotalTableToolbar;
